export default __webpack_public_path__ + "static/media/KneeStabilityAtLoadingResponse.7d826f2f.png";